export default "__VITE_ASSET__687e19be__"